import { render } from "./ForgetPasswordVerify.vue?vue&type=template&id=d5aad688&ts=true"
import script from "./ForgetPasswordVerify.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordVerify.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__